<template>
  <div class="wrap mt-5">
    <div v-if="timeMsg == ''" class="d-flex flex-column align-items-center cards">
      <div class="w-100 lanWrap">
        <span class="lanBox" :class="{'active' : currentMsg == 'USDT'}"
         @click="currentMsg='USDT'">
          中文
        </span>
        <span class="lanBox" :class="{'active' : currentMsg == 'VND'}"
         @click="currentMsg = 'VND'">
          Tiếng Việt
        </span>
      </div>
      <div class="row inputWrap">
        <div class="col-12">
          <h4 class="ml-1 text-center">{{returnLag(1)}}：{{ order.remark == 'VND' ? '₫' :  order.remark == 'CNY' ? '¥' : '' }} {{ order.bill_price }}</h4>
          <h5 class="ml-1 text-center">{{returnLag(2)}}： <span class="text-danger">{{time}}</span></h5>
          <h5 class="ml-1 text-center">{{returnLag(3)}} <span class="text-danger">{{order.real_price}}</span> USDT</h5>
          <h5 class="ml-1 text-center text-danger">「{{returnLag(4)}}」</h5>
          <!-- <img class="mt-3 mb-1 qrCode" :src="order.qr_url" alt /> -->
          <div class="qrcode" v-if="order">
            <vue-qrcode :margin="1" :value="order.bank_no" :width="200" />
          </div>
        </div>
        <div class="col-12">
          <h6 class=" text-center">{{returnLag(5)}}</h6>
          <p class=" text-center w-100">
            {{order.bank_no}}
          </p>
          <div class="d-flex justify-content-center">
          <button v-clipboard:copy="order.bank_no"
              v-clipboard:success="onCopy" class="btn btn-green">{{returnLag(6)}}</button>
          </div>
        </div>
      </div>
      <div class="w-100">
        <p class="mb-0 mt-3 text-left">{{returnLag(7)}}:</p>
        <p class="text-left">1.{{returnLag(8)}} {{order.bank_from}} {{returnLag(9)}}。 </p>
        <p class="text-left">2.{{returnLag(10)}}<span class="text-danger h5">{{order.rate}} </span >{{returnLag(11)}}。 </p>
        <p class="text-left">3.{{returnLag(12)}}<span class="text-danger h5">{{order.real_price}}</span> USDT <span class="text-danger dnagerText" style="fint-size:2rem">「{{returnLag(13)}}」</span>，{{returnLag(19)}}。 </p>
        <p class="text-left">4.{{returnLag(14)}}。 </p>
        <p class="text-left text-danger">5.{{returnLag(15)}}！ </p>
        <p class="text-left text-danger">6.{{returnLag(16)}}！ </p>
        <p class="text-left text-danger">7.{{returnLag(17)}}！ </p>
      </div>
    </div>
    <div v-else>
      <h4 class="tit1">{{timeMsg}}</h4>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueQrcode from 'vue-qrcode'
export default {
  components: {
    VueQrcode,
  },
  data() {
    return {
      order: false,
      // order: "",
      timeout: "",
      timeMsg: "",
      time:'',
      endTime:'',
      currentMsg:'USDT',
      first:true,
      VND:{
        1: 'Số tiền nạp',
        2: 'Thời gian còn lại',
        3: 'Vui lòng chuyển khoản',
        4: 'Xin lưu ý rằng số tiền không bao gồm phí chuyển khoản',
        5: 'địa chỉ nạp tiền',
        6: 'Sao chép',
        7: 'Chú ý',
        8: 'Không trả bất cứ thứ gì cho địa chỉ trên',
        9: 'Tài sản, nếu không tài sản sẽ không được truy xuất',
        10: 'Hiện tại trao đổi Okex / Huobi / Binance USDT theo đơn giá ngoài thị trường mới nhất',
        11: 'Nhân dân tệ',
        12: 'Hãy đảm bảo rằng địa chỉ thanh toán được nhận',
        13: 'Phí chuyển khoản chưa bao gồm, bạn phải tự tính toán',
        14: 'Sau khi thanh toán đến địa chỉ trên, bạn cần xác nhận toàn bộ nút mạng, vui lòng kiên nhẫn chờ đợi',
        15: 'Nếu bạn sử dụng Ví Huobi, vui lòng không chọn phương thức Heco-Peg USDTHECO Token để rút tiền vì kênh này không hỗ trợ chuyển mạng và sẽ không lấy được tài sản',
        16: 'Nếu bạn sử dụng nền tảng giao dịch Binance, vui lòng không chọn Binance-Peg (BUSD-T) để rút tiền vì kênh này không hỗ trợ chuyển mạng và sẽ không lấy được tài sản',
        17: 'Nếu bạn sử dụng U, ETH, TRX và các đơn vị tiền tệ không được chứng nhận khác với USDT (tiền tệ Teda) để thanh toán, kênh này không được hỗ trợ và không thể truy xuất nội dung để làm thông tin của bạn.',
        18: 'Sao chép thành công',
        19: 'Nếu không, nó không thể được ghi có vào tài khoản'
      },
      USDT:{
        1:'充值金额',
        2:'剩余时间',
        3:'请转入',
        4:'请注意,该金额不含转账手续费',
        5:'充值地址',
        6:'复制',
        7:'注意',
        8:'请勿向上述地址支付任何非',
        9:'资产，否则资产将无法找回',
        10:'当前Okex/火币/币安交易所USDT 最新场外卖出单价',
        11:'元',
        12:'请确保收款地址收到',
        13:'不含转账手续费,须自行计算',
        14:'您支付至上述地址后，需要整个网络节点的确认，请耐心等待',
        15:'如使用火币钱包，请勿选择Heco-Peg USDTHECO Token方式提币，因为此渠道不支持网络互转，资产将无法找回',
        16:'如使用币安交易平台，请勿选择Binance-Peg (BUSD-T) 的方式提币，因为此渠道不支持网络互转，资产将无法找回',
        17:'如使用未认证U、ETH、TRX以及USDT(泰达币)外的币种进行支付,此渠道并无支持,资产无法找回,供您知悉',
        18:'复制成功',
        19:'否则无法到账'
      },
      CNY:{
        1:'充值金额',
        2:'剩余时间',
        3:'请转入',
        4:'请注意,该金额不含转账手续费',
        5:'充值地址',
        6:'复制',
        7:'注意',
        8:'请勿向上述地址支付任何非',
        9:'资产，否则资产将无法找回',
        10:'当前Okex/火币/币安交易所USDT 最新场外卖出单价',
        11:'元',
        12:'请确保收款地址收到',
        13:'不含转账手续费,须自行计算',
        14:'您支付至上述地址后，需要整个网络节点的确认，请耐心等待',
        15:'如使用火币钱包，请勿选择Heco-Peg USDTHECO Token方式提币，因为此渠道不支持网络互转，资产将无法找回',
        16:'如使用币安交易平台，请勿选择Binance-Peg (BUSD-T) 的方式提币，因为此渠道不支持网络互转，资产将无法找回',
        17:'如使用未认证U、ETH、TRX以及USDT(泰达币)外的币种进行支付,此渠道并无支持,资产无法找回,供您知悉',
        18:'复制成功',
        19:'否则无法到账'
      }
    };
  },
  computed: {},
  methods: {
    returnLag(key){
      return this[this.currentMsg][key]
    },
    onCopy(){
      this.$message.success(this.returnLag(18))
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
            this.endTime = res.data.data.expired;
            if(this.first) {
              if(res.data.data.remark == 'VND' || res.data.data.remark == 'USDT' || res.data.data.remark == 'CNY' ) {
                this.currentMsg = res.data.data.remark;
              }
              this.first = false
            }
            this.timeOut()
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    },
    timeOut(){
    let ths = this
    let endTime = new Date(this.endTime.replace(/-/g, "/"));
    function checktime(){
      if(endTime.getTime() < new Date().getTime()){
        clearInterval(close)
        ths.timeMsg = '订单逾期失效'
      }
        let now = new Date(),
            diff = new Date(endTime - now);
        ths.time = diff.Myformat();
    }

    Date.prototype.Myformat = function(){
        return ("0"+ this.getUTCHours()).slice(-2)+":"+("0"+this.getUTCMinutes()).slice(-2)+":"+("0"+ this.getUTCSeconds()).slice(-2)
    }

    let close = setInterval(checktime, 1000);
    }
  },
  created() {
    this.getOrder();
  }
};
</script>
<style lang="scss">

  .flx {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .dnagerText {
    width: 100%;
  }
body {
  background-color: #EBEFF0 !important;
}
.wrap {
  padding: 25px;
  width: 95%;
  margin-left: 2.5%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}
p {
  color:black;
  word-break:break-all;
}
.cards {
  box-shadow: 1;
  background-color: #fff;
  display: block;
  padding: 50px;
  border-radius: 10px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
}
@media(max-width:768px) {
  .cards {
    padding: 20px
  }
}

  .lanWrap {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    .lanBox {
      padding: 3px 5px;
      border: 1px solid black;
      border-radius: 3px;
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
      &.active {
        color:white;
        background-color: #4669E7;
        border: 1px solid gray;
      }
    }
  }
</style>